<template>
  <hm-content title="">
    <div v-if="commType === 'money'">
      <div class="flex text-right  flex-end">
        <el-input
          clearable
          style="width: 200px"
          v-model.trim="searchCondition.keyword"
          placeholder="请输入姓名/电话"
          size="small"
          class="ipt mr10"
        ></el-input>
        <!-- <el-select
          size="small"
          clearable
          placeholder="请选择提现审批状态"
          v-model="searchCondition.getcashApprovalState"
          class="mr10"
          filterable
        >
          <el-option label="申请" value="apply"></el-option>
          <el-option label="同意" value="agree"></el-option>
          <el-option label="转账" value="pay"></el-option>
          <el-option label="拒绝" value="refuse"></el-option>
         
        </el-select> -->

        <el-input
          clearable
          style="width: 100px"
          v-model.trim="searchCondition.minGetcashCommission"
          placeholder="可提现下限"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          style="width: 100px"
          v-model.trim="searchCondition.maxGetcashCommission"
          placeholder="可提现上限"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchCondition.date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="选择申请起始日期"
          end-placeholder="选择申请起始日期"
        ></el-date-picker>

        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="info" size="small" @click="searchCondition = {}"
          >重置</el-button
        >
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出模板</el-button
        >
      </div>
      <div class="table">
        <div class="flex  flex-end batch item-center">
          <div @click="batchSetting">
            <span class="delete-icon hmicon icon-xitong"></span>
            批量同意<span class="ml20">已选{{ num }}条</span>
          </div>
        </div>

        <div class="flex  flex-between mb10">
          <div>
            <el-radio-group
              v-model="searchCondition.getcashApprovalState"
              size="small"
              @change="switchTab"
            >
              <el-radio-button label="apply">待审核</el-radio-button>
              <el-radio-button label="agree">待转账</el-radio-button>
              <el-radio-button label="pay">已转账</el-radio-button>
              <el-radio-button label="refuse">拒绝</el-radio-button>
              <el-radio-button label="all">全部</el-radio-button>
            </el-radio-group>
          </div>
          <div class="flex item-center" style="marginBottom:-30px">
            &nbsp 已支付总额：<span class="success"
              >¥{{ extractTotal.totalPayGetcashCommission }}</span
            >
            &nbsp 待支付总额：<span class="blue"
              >¥{{ extractTotal.totalGetcashCommission }}</span
            >
          </div>
        </div>
        <!-- <div class="hm-radio-group">
        <el-radio-group v-model="dateFlag" size="small" @change="switchTab">
          <el-radio-button label="0"
            >全部({{ myActivityList.stateCount.totalCount }})</el-radio-button
          >
          <el-radio-button label="2">
            进行中({{ myActivityList.stateCount.ongoingCount }})
          </el-radio-button>
          <el-radio-button label="1">
            未开始({{ myActivityList.stateCount.notStartCount }})
          </el-radio-button>
          <el-radio-button label="3"
            >已结束({{ myActivityList.stateCount.endCount }})</el-radio-button
          >
        </el-radio-group>
      </div> -->

        <el-table
          @sort-change="sortChange"
          stripe
          border
          @selection-change="getChecked"
          ref="multipleTable"
          :data="extractManageList.records"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="selection"
            :selectable="checkboxT"
          ></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="getcashSn"
            label="提现单号"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="getcashApprovalState"
            label="提现单状态"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.getcashApprovalState === 'apply'"
                class="success"
                >已申请</span
              >
              <span
                v-if="scope.row.getcashApprovalState === 'agree'"
                class="success"
                >已同意</span
              >
              <span
                v-if="scope.row.getcashApprovalState === 'pay'"
                class="success"
                >已转账</span
              >
              <span
                v-if="scope.row.getcashApprovalState === 'refuse'"
                class="danger"
                >已拒绝</span
              >
              <!-- <span
              v-if="scope.row.getcashApprovalState === 'confirmed'"
              class="success"
              >已确认</span
            > -->
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="memberName"
            label="姓名"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="memberMobile"
            label="电话"
          >
          </el-table-column>
          <el-table-column
            prop="receiveAccount"
            header-align="center"
            align="center"
            label="收款账户"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.receiveMode === 'alipay'"
                >支付宝:{{ scope.row.receiveAccount }}</span
              >
              <span v-if="scope.row.receiveMode === 'wxpay'"
                >微信:{{ scope.row.receiveAccount }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="allowGetcashMoneyAmount"
            label="可提现佣金"
          >
            <template
              slot-scope="scope"
              v-if="scope.row.allowGetcashMoneyAmount"
            >
              <span>¥{{ scope.row.allowGetcashMoneyAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="getcashCommission"
            label="申请金额"
          >
            <template slot-scope="scope">
              <span>¥{{ scope.row.getcashCommission }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="getcashTime"
            label="申请日期"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="returnReceiptSn"
            label="转账流水号"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shareGetcashOrderLogVos"
            label="操作记录"
            width="300"
          >
            <template slot-scope="scope">
              <div
                class="table game-select"
                v-if="scope.row.shareGetcashOrderLogVos.length > 0"
              >
                <div class="table-header flex">
                  <div
                    class="flex-1 text-center"
                    v-for="(v, i) in titleList"
                    :key="i"
                  >
                    {{ v.title }}
                  </div>
                </div>
                <div class="table-body">
                  <div
                    class="flex table-row item-center"
                    v-for="(v, i) in scope.row.shareGetcashOrderLogVos"
                    :key="i"
                  >
                    <div class="flex-1 text-center">{{ v.operationName }}</div>
                    <div
                      class="flex-1 text-center"
                      v-if="v.operationState === 'agree'"
                    >
                      同意
                    </div>
                    <div
                      class="flex-1 text-center"
                      v-if="v.operationState === 'pay'"
                    >
                      转账
                    </div>
                    <div
                      class="flex-1 text-center"
                      v-if="v.operationState === 'refuse'"
                    >
                      拒绝
                    </div>
                    <div class="flex-1 text-center">{{ v.operationTime }}</div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            header-align="center"
            align="center"
            width="130"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-tooltip class="item" content="转账" placement="top">
                  <button
                    :disabled="scope.row.getcashApprovalState !== 'agree'"
                    class="pointer mr10 no-bg"
                    @click="payment(scope.row)"
                  >
                    <span
                      class="hmicon icon-fukuan "
                      :class="
                        scope.row.getcashApprovalState === 'agree'
                          ? 'success'
                          : 'gray'
                      "
                    ></span>
                  </button>
                </el-tooltip>

                <el-tooltip class="item" content="同意" placement="top">
                  <button
                    :disabled="scope.row.getcashApprovalState !== 'apply'"
                    class="pointer mr10 no-bg"
                    @click="consent(scope.row)"
                  >
                    <span
                      class="hmicon icon-tongyi "
                      :class="
                        scope.row.getcashApprovalState === 'apply'
                          ? 'blue'
                          : 'gray'
                      "
                    ></span>
                  </button>
                </el-tooltip>

                <el-tooltip class="item" content="拒绝" placement="top">
                  <button
                    :disabled="scope.row.getcashApprovalState !== 'apply'"
                    class="pointer mr10 no-bg"
                    @click="refuse(scope.row)"
                  >
                    <span
                      class="hmicon icon-jujue "
                      :class="
                        scope.row.getcashApprovalState === 'apply'
                          ? 'primary'
                          : 'gray'
                      "
                    ></span>
                  </button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex flex-start">
          申请总人数：<span>{{ extractTotal.totalAllNum }}</span> &nbsp
          待审核人数：<span class="success">{{
            extractTotal.totalApplyNum
          }}</span>
          &nbsp 待支付人数：<span class="danger">{{
            extractTotal.totalAgreeNum
          }}</span>
        </div>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="extractManageList.total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
            :page-size="pageSize"
          ></el-pagination>
        </div>
      </div>
      <el-dialog
        title="批量审批"
        width="70%"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
      >
        <div class="table-panel flex  flex-start">
          <el-button type="primary" size="small" @click="dialogVisible = false"
            >继续添加</el-button
          >
        </div>
        <div class="table-panel flex  flex-end">
          当前提现总金额：<span class="primary" style="fontSize:18px"
            >¥{{ total }}
          </span>
        </div>
        <el-table
          stripe
          border
          class="mb20"
          ref="brandTable"
          :data="checkedRow"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentMicroPage - 1) * pageMicroSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="memberName"
            label="姓名"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="memberMobile"
            label="电话"
          >
          </el-table-column>

          <el-table-column
            prop="receiveAccount"
            header-align="center"
            align="center"
            label="收款账户"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="getcashCommission"
            label="申请金额"
          >
            <template slot-scope="scope">
              <span>¥{{ scope.row.getcashCommission }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-tooltip class="item" content="删除" placement="top">
                  <button
                    class="pointer mr10 no-bg"
                    @click="remove(scope.$index)"
                  >
                    <span class="hmicon icon-shanchu primary"></span>
                  </button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <p class="p2019">
          批量支付无法查看每个会员详情，请核对上方清单及清单中对应会员的详细信息后支付。否则可能
          导致不必要的损失。
        </p>

        <div class="flex flex-center">
          <el-button
            :disabled="checkedRow.length == 0"
            type="primary"
            size="small"
            @click="batchAffirm"
            >确认</el-button
          >
          <el-button size="small" @click="dialogVisible = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        :title="title"
        width="50%"
        :close-on-click-modal="false"
        :visible.sync="dialogVisibleRefuse"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="product-ruleForm"
        >
          <el-form-item label="拒绝理由" prop="remark" v-if="flag === 'jujue'">
            <el-input
              size="small"
              clearable
              class="mr10 ipt"
              type="textarea"
              v-model.trim="ruleForm.remark"
              placeholder="请输入拒绝理由，必填"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="流水单号"
            prop="returnReceiptSn"
            v-if="flag === 'liushui'"
          >
            <el-input
              size="small"
              clearable
              style="width:300px"
              class="mr10 ipt"
              v-model.trim="ruleForm.returnReceiptSn"
              placeholder="请填写转账流水单号"
            ></el-input>
            <div class="p2019" v-if="flag === 'liushui'">
              该单号本系统制作存储，方便财务后期核对账务使用
            </div>
          </el-form-item>
        </el-form>
        <div class="btn-wrapper flex flex-center">
          <el-button size="small" type="primary" @click="keep('ruleForm')"
            >确 定</el-button
          >
          <el-button size="small" @click="dialogVisibleRefuse = false"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div
      class="flex flex-center item-center"
      style="fontSize:20px;"
      v-if="commType === 'point'"
    >
      您当前使用的是积分返佣模式，不涉及提现管理相关功能。
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      ruleForm: {
        remark: "",
        returnReceiptSn: ""
      },
      titleList: [
        {
          title: "用户名"
        },
        {
          title: "操作"
        },
        {
          title: "时间"
        }
      ],
      rules: {
        remark: [
          {
            required: true,
            message: "请输入拒绝理由",
            trigger: "blur"
          }
        ],
        returnReceiptSn: [
          {
            required: true,
            message: "请填写转账流水单号",
            trigger: "blur"
          }
        ]
      },
      num: 0,
      searchCondition: {
        getcashApprovalState: "apply"
      },
      title: "拒绝",
      flag: "liushui",
      isOutputing: false,
      currentPage: 1,
      pageSize: 10,
      currentMicroPage: 1,
      pageMicroSize: 10,
      dialogVisible: false,
      dialogVisibleRefuse: false,
      checkedRow: [],
      total: 0,
      getcashId: "",
      shareCenterId: "",
      getcashCommission: "",
      commType: ""
    };
  },
  computed: mapGetters(["extractManageList", "extractTotal"]),
  watch: {
    checkedRow(val) {
      if (val.length > 0) {
        val.map(v => {
          this.total += v.getcashCommission;
        });
      } else {
        this.$refs.multipleTable.clearSelection();
        this.total = 0;
      }
    }
  },
  created() {
    this.getParamsCookie();
    this.$store.dispatch("detailsRule").then(res => {
      if (res.result) {
        this.commType = res.result.commissionMode;
        if (res.result.commissionMode === "money") {
          this.queryList();
          this.queryTotal();
        }
      } else {
        this.$confirm(" 请先设置分销规则", "提示", {
          // cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning"
        })
          .then(() => {
            this.$router.push({
              name: "DistributionRule"
            });
          })
          .catch(() => {
            this.$router.push({
              name: "DistributionRule"
            });
          });
      }
    });
  },
  mounted() {},
  methods: {
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    queryTotal() {
      return this.$store.dispatch("queryTotal");
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.startGetcashTime = this.isArray(searchCondition.date)
        ? searchCondition.date[0]
        : "";

      searchCondition.endGetcashTime = this.isArray(searchCondition.date)
        ? searchCondition.date[1]
        : "";
      searchCondition.getcashApprovalState =
        searchCondition.getcashApprovalState === "all"
          ? ""
          : searchCondition.getcashApprovalState;
      Object.assign(params, searchCondition);
      this.setParamsCookie();
      return this.$store.dispatch("extractManageList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "extractManageParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "extractManageParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryAllList() {
      let params = {
        pageSize: 99999,
        pageNo: 1
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.startGetcashTime = this.isArray(searchCondition.date)
        ? searchCondition.date[0]
        : "";

      searchCondition.endGetcashTime = this.isArray(searchCondition.date)
        ? searchCondition.date[1]
        : "";
      Object.assign(params, searchCondition);

      return this.$store.dispatch("extractManageList", params);
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },

    batchSetting() {
      if (this.checkedRow.length) {
        this.dialogVisible = true;

        this.total = 0;
        this.checkedRow.map(v => {
          this.total += v.getcashCommission;
        });
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    checkboxT(row) {
      if (
        row.getcashApprovalState === "refuse" ||
        row.getcashApprovalState === "pay"
      ) {
        return false;
      } else {
        return true;
      }
    },
    getChecked(selection) {
      this.checkedRow = selection;
      this.num = selection.length;
    },
    shareGetcashOrder(params) {
      return this.$store.dispatch("shareGetcashOrder", params);
    },
    payment(row) {
      this.dialogVisibleRefuse = true;
      this.title = "转账流水单号";
      this.flag = "liushui";
      this.getcashId = row.getcashId;
      this.shareCenterId = row.shareCenterId;
      this.getcashCommission = row.getcashCommission;
    },
    consent(row) {
      let params = {
        operationType: "agree",
        getcashId: row.getcashId
      };
      this.shareGetcashOrder(params).then(res => {
        if (res.code === "0") {
          this.$message({
            type: "success",
            message: "操作成功！"
          });
          this.queryList();
          this.queryTotal();
        }
      });
    },
    refuse(row) {
      this.dialogVisibleRefuse = true;
      this.title = "拒绝";
      this.flag = "jujue";
      this.getcashId = row.getcashId;
      this.shareCenterId = row.shareCenterId;
      this.getcashCommission = row.getcashCommission;
    },
    sortChange(sort) {},

    remove(i) {
      this.checkedRow.splice(i, 1);
    },
    batchAffirm() {
      if (this.checkedRow.length > 0) {
        let params = {};
        params.getcashIds = this.checkedRow.map(v => v.getcashId);
        this.$store.dispatch("payBatch", params).then(res => {
          if (res.code === "0") {
            this.dialogVisible = false;
            this.$message({
              type: "success",
              message: "操作成功！"
            });

            this.queryList();
            this.queryTotal();
          }
        });
      }
    },
    keep(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          let par = {
            operationType: this.flag === "liushui" ? "pay" : "refuse",
            getcashId: this.getcashId,
            shareCenterId: this.shareCenterId,
            getcashCommission: this.getcashCommission
          };
          Object.assign(params, par);
          this.shareGetcashOrder(params).then(res => {
            if (res.code === "0") {
              this.dialogVisibleRefuse = false;
              this.$message({
                type: "success",
                message: "操作成功！"
              });

              this.queryList();
              this.queryTotal();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;

        this.queryAllList()
          .then(res => {
            let list = res.result.records;

            list.forEach((v, i) => {
              v.index = i + 1;
            });
            let tHeader = [
              "序号",
              "收款方支付宝账号",
              "收款方姓名",
              "金额(元)",
              "备注"
            ];

            let filterVal = [
              "index",
              "receiveAccount",
              "memberName",
              "getcashCommission",
              "xxxx"
            ];

            let title = "支付宝批量付款模板";

            let data = this.formatJson(filterVal, list);

            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
.batch {
  div {
    margin: 20px 0 0 0;
    cursor: pointer;
    font-size: 14px;
    color: #222222;
    user-select: none;
    &:first-child {
      margin-right: 20px;
    }
  }
  .hmicon {
    margin-right: 5px;
  }
}
.p2019 {
  color: rgba(102, 102, 102, 1);
  font-size: 12px;
}
</style>
